import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { SofboxModule } from './sofbox/sofbox.module';
import { LandingPage8Module } from './landing-page8/landing-page8.module';
import { LandingPage1Module } from './landing-page1/landing-page1.module';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { HttpClientModule } from '@angular/common/http';
import { ContactFormService } from './sofbox/components/contact-form/contact-form.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenav, MatSidenavContainer, MatSidenavContent, MatTable, MatTableDataSource, MatTableModule } from '@angular/material';
import { NgxMaskModule } from 'ngx-mask-2';

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    MatSidenav,
    MatSidenavContainer,
    MatSidenavContent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SofboxModule,
    LandingPage8Module,
    LandingPage1Module,
    RecaptchaModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxMaskModule.forRoot(),

  ],
  providers: [
    ContactFormService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
